import script from "./FloatingNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingNavbar.vue?vue&type=script&setup=true&lang=js"

import "./FloatingNavbar.vue?vue&type=style&index=0&id=285f754a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285f754a"]])

export default __exports__